import { render, staticRenderFns } from "./TomorrowAndTomorrowAndTommorowArticle.vue?vue&type=template&id=1cafe6ba&"
import script from "./TomorrowAndTomorrowAndTommorowArticle.vue?vue&type=script&lang=js&"
export * from "./TomorrowAndTomorrowAndTommorowArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports